export enum BookingOption {
    BOOK_NOW = 'BOOK_NOW',
    BOOK_LATER = 'BOOK_LATER',
    ADVERTISE = 'ADVERTISE'
}
